import api from './api';

const vaultService = {
  getAllVaults: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.hotelid) params.append('hotelid', filters.hotelid);
      if (filters.accountid) params.append('accountid', filters.accountid);
      if (filters.partnerid) params.append('partnerid', filters.partnerid);
      if (filters.vaultid) params.append('vaultid', filters.vaultid);
      if (filters.name) params.append('name', filters.name);
      if (filters.showDeleted) params.append('showDeleted', 'true');

      const response = await api.get(`/vault?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching vaults:', error);
      throw error;
    }
  },

  getVaultById: async (id, hotelid = null) => {
    try {
      const params = new URLSearchParams();
      if (hotelid) params.append('hotelid', hotelid);
      const response = await api.get(`/vault/${id}${params.toString() ? '?' + params.toString() : ''}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching vault ${id}:`, error);
      throw error;
    }
  },

  createVault: async (vaultData) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(vaultData).map(([key, value]) => [
          key,
          value === '' ? null : value
        ])
      );

      const response = await api.post('/vault', cleanedData);
      return response.data;
    } catch (error) {
      console.error('Error creating vault:', error);
      throw error;
    }
  },

  updateVault: async (id, vaultData) => {
    try {
      const cleanedData = Object.fromEntries(
        Object.entries(vaultData).map(([key, value]) => [
          key,
          value === '' ? null : value
        ])
      );

      const response = await api.put(`/vault/${id}`, cleanedData);
      return response.data;
    } catch (error) {
      console.error(`Error updating vault ${id}:`, error);
      throw error;
    }
  },

  getCredentialSources: async (hotelId) => {
    try {
      const response = await api.get(`/vault?credential_sources=1&hotel_id=${hotelId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching credential sources:', error);
      throw error;
    }
  },

  deleteVault: async (id, hotelid = null) => {
    try {
      const params = new URLSearchParams();
      if (hotelid) params.append('hotelid', hotelid);
      const response = await api.delete(`/vault/${id}${params.toString() ? '?' + params.toString() : ''}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting vault ${id}:`, error);
      throw error;
    }
  }
};

export default vaultService;
